<template>
  <v-app>
    <v-app-bar v-if="isLoggedIn" app fixed elevate-on-scroll color="white">
      <v-btn :to="{name: 'Home'}" text exact>Home</v-btn>
      <v-btn :to="{name: 'Profile'}" text>Profile</v-btn>
      <users-menu />
      <v-btn :to="{name: 'Lists'}" text >Lists</v-btn>
      <v-btn :to="{name: 'Films'}" text >Films</v-btn>
      <add-dialog />
      <v-spacer />
      <search-bar />
      <notification-menu />
      <account-menu />
    </v-app-bar />
    <v-main v-if="isLoggedIn">
      <router-view />
    </v-main>
    <login-dialog ref="LoginDialog" />
    <snackbar ref="Snackbar" />
    <v-footer v-if="loading" app fixed>
      <em class="mx-auto">{{ loading }}</em>
    </v-footer>
  </v-app>
</template>

<script>
import HttpClient from "@/utils/HttpClient"
import SearchBar from "@/components/search/SearchBar"
import NotificationMenu from "@/components/app/NotificationMenu"
import AccountMenu from "@/components/app/AccountMenu"
import UsersMenu from "@/components/app/UsersMenu"
import LoginDialog from "@/components/app/LoginDialog"
import Snackbar from "@/components/app/Snackbar"
import AddDialog from "@/components/app/AddDialog"

export default {
  name : "App",
  components: {
    SearchBar,
    NotificationMenu,
    AccountMenu,
    UsersMenu,
    LoginDialog,
    Snackbar,
    AddDialog,
  },
  data() {
    return {
      loading: '',
      httpClient: new HttpClient(this.login, {
        start: () => this.loading = "Loading...",
        progress: (done, total) => this.loading = `Loading ${done}/${total}`,
        end: () => this.loading = '',
      })
    }
  },
  provide() {
    return {
      httpClient: this.httpClient,
      snackbar: (message, color) => this.$refs.Snackbar.show(message, color)
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    me() {
      return this.$store.state.me
    },
    isLoggedIn() {
      return !!this.me
    },
  },
  methods: {
    async load() {
      const me = await this.httpClient.loadMe()
      this.$store.commit("setMe", me)
    },
    login() {
      return this.$refs.LoginDialog.pop()
    },
  },
}
</script>

<style>
* {
  font-size: 14px;
}
a {
  text-decoration: none;
}
table {
  width: 100%;
  margin: 1em 0;
  border: 1px solid #d0d0d0;
  border-collapse: collapse;
}
table tbody tr:hover {
  box-shadow: 0px 0px 2px 0px blue;
}
table td, table th {
  padding: .5em .7em;
  border-top: 1px solid #d4d4d4;
  text-align: left;
}
table th {
  white-space: nowrap;
  cursor: pointer;
}
table th.sortable:hover {
  box-shadow: 0px -1px 0px 0px gray inset;
}
</style>
